import { render, staticRenderFns } from "./collapseItem.vue?vue&type=template&id=5f40edb4&scoped=true&"
import script from "./collapseItem.vue?vue&type=script&lang=ts&"
export * from "./collapseItem.vue?vue&type=script&lang=ts&"
import style0 from "./collapseItem.vue?vue&type=style&index=0&id=5f40edb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40edb4",
  null
  
)

export default component.exports